/**
 * @generated SignedSource<<29b585ec61eceb8cff0600dcce8b2f2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NumberTaskUnit = "CURRENCY" | "CUSTOM";
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
import { FragmentRefs } from "relay-runtime";
export type TaskListItemIcon_Task$data = {
  readonly __typename: "TaskCheck";
  readonly sentiments: ReadonlyArray<TaskSentiment>;
  readonly " $fragmentType": "TaskListItemIcon_Task";
} | {
  readonly __typename: "TaskNumber";
  readonly unit: NumberTaskUnit;
  readonly " $fragmentType": "TaskListItemIcon_Task";
} | {
  readonly __typename: "TaskText";
  readonly __typename: "TaskText";
  readonly " $fragmentType": "TaskListItemIcon_Task";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "TaskListItemIcon_Task";
};
export type TaskListItemIcon_Task$key = {
  readonly " $data"?: TaskListItemIcon_Task$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskListItemIcon_Task">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskListItemIcon_Task",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit",
          "storageKey": null
        }
      ],
      "type": "TaskNumber",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sentiments",
          "storageKey": null
        }
      ],
      "type": "TaskCheck",
      "abstractKey": null
    }
  ],
  "type": "Task",
  "abstractKey": "__isTask"
};

(node as any).hash = "3f0ed14a2988cd99e49ab60cdb5034be";

export default node;
